module.exports = __webpack_public_path__ + "static/media/53.af1568db.jpg";